import { render, staticRenderFns } from "./pagamentoJobs.vue?vue&type=template&id=20ed03af&"
import script from "./pagamentoJobs.vue?vue&type=script&lang=js&"
export * from "./pagamentoJobs.vue?vue&type=script&lang=js&"
import style0 from "./pagamentoJobs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports